module.exports = __webpack_public_path__ + "img/hezuoxiaoyuan_bg.c3226a1d.png";